'use client';
import Image, { StaticImageData } from "next/image";
import React from "react";

interface BlogCardsProps {
    title: string;
    author: string;
    date: string;
    img: string | StaticImageData;
    blogUrl: string;
    isLoading?: boolean;
}

const BlogCards: React.FC<BlogCardsProps> = ({ blogUrl, title, author, date, img }) => {
    return (
        <div className={`md:w-[368px] min-w-[300px] flex-1 cursor-pointer h-auto`} onClick={() => window.location.href = blogUrl}>
            <div>
                <Image
                    src={img}
                    alt={title}
                    width={368}
                    height={207}
                    className="h-[137px] md:h-[207px] w-full object-cover mb-6"
                />
                <div className="bg-transparent mb-s13 md:mb-0">
                    <h2 className="text-xl font-semibold leading-[26px] mb-2">{title}</h2>
                    <p className="text-sm font-normal text-gray-500 leading-[16.8px]">
                        {author} · {date}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default BlogCards;
